import { isDefined } from '@sgme/fp';
import { useSgwtWidgets } from '@sgwt/sgwt-widgets-react';

import {
  useCheckTargetAccumulatorByTradeCapture,
  useTargetAccumulatorSelector,
  useTargetAccumulatorTileId,
} from '@/App/tiles/TargetAccumulator/TargetAccumulatorContext.tsx';
import { TargetAccumulatorFormField } from '@/App/tiles/TargetAccumulator/TargetAccumulatorFormField.tsx';
import { SgNumberInput } from '@/components/sg-design-system/components/input/SgNumberInput/index.tsx';
import { TradeCaptureValidationWrapper } from '@/components/ui/TradeCaptureFieldErrorWrapper.tsx';
import { useAppSelector } from '@/store/hooks.ts';
import { selectTargetAccumulatorValidation } from '@/store/targetAccumulator/selectors.ts';

const Strike = () => {
  const tileId = useTargetAccumulatorTileId();
  const strike = useTargetAccumulatorSelector((targetAccumulator) => targetAccumulator?.properties.strike);
  const isCustom = useTargetAccumulatorSelector(
    (targetAccumulator) => targetAccumulator?.properties.customFields?.includes('Strike') ?? false,
  );
  const validation = useAppSelector((state) => selectTargetAccumulatorValidation(state, tileId))?.strike;
  const { sgwtWebAnalytics } = useSgwtWidgets();

  const checkTargetAccumulatorWithTradeCapture = useCheckTargetAccumulatorByTradeCapture();

  const handleStrike = (value: number | undefined) => {
    sgwtWebAnalytics?.trackEvent('Target Accumulator', 'Strike changed', isDefined(value) ? String(value) : 'cleared');

    return checkTargetAccumulatorWithTradeCapture({
      strike: isDefined(value) ? value : null,
    });
  };

  return (
    <TargetAccumulatorFormField formattedMessageId="targetAccumulator.form.strike">
      <TradeCaptureValidationWrapper validation={validation}>
        <SgNumberInput
          valuePosition="start"
          className={isCustom ? 'text-info' : undefined}
          data-e2e-is-modified={isCustom}
          selectAllOnFocus
          value={strike}
          maxDecimals={9}
          allowNegative={false}
          onChange={handleStrike}
          size="sm"
          data-e2e="strike"
        />
      </TradeCaptureValidationWrapper>
    </TargetAccumulatorFormField>
  );
};

export default Strike;
